import React, { useEffect, useState} from 'react';
import {  Container, Col } from 'reactstrap';
import LoginModal from '../../shared/components/Modals/LoginModal';
import { connect } from 'react-redux';

import { getApiByFriendlyName } from '../../redux/actions/apis';
import RateLimitUpgradeModal from '../../shared/components/Modals/UpgradeModals/RateLimitUpgradeModal';

import { getPlanByApiAndOrganization } from '../../redux/actions/plans';
import { getImageLayouts, getOrganizationImageDesigns } from '../../redux/actions/linkPreview';

import LinkPreviewTool from './components/LinkPreviewTool/LinkPreviewTool';

import './linkPreview.css';

const LinkPreview = (props) => {
  const [ displayLoginModal, setDisplayLoginModal ] = useState(false);
  const [currentPlan, setCurrentPlan] = useState(null);

  const [ activeTab, setActiveTab ] = useState('dashboard');

  useEffect(() => {
    if(!props.api.id && !props.apiError) {
      props.getApiByFriendlyName('Opengraphio');
    }
  }, [props.api])

  useEffect(() => {
    if (!props.user && !props.userState.loading) {
      setDisplayLoginModal(true);
    }
    if (props.user && props.api.id && !props.plan.id && !props.planError) {
      props.getPlanByApiAndOrganization();
    }

  }, [props.api.id, props.user, props.plan.id, props.planError, props.apiError]);


  useEffect(() => {
    if(props.plan && props.plan.tierId && props.api && props.api.tiers){
      setCurrentPlan(props.api.tiers.find((tier) => tier.id === props.plan.tierId))
    }

  }, [props.plan, props.api])

  useEffect(() => {
    if(props.user) {
      setDisplayLoginModal(false);
    }
  }, [props.user]);

  useEffect(() => {
    if(props.user && props.currentOrganization.information.id && props.plan.id) {
      if(props.imageDesigns.designs.length === 0) {
        props.getOrganizationImageDesigns();
      }
    }
  }, [props.user, props.currentOrganization.information, props.plan.id]);

  useEffect(() => {
    if(props.imageLayouts.layouts.length === 0 && props.plan.id) {
      props.getImageLayouts();
    }
  }, [props.plan.id]);

  useEffect(() => {
    if(props.selectedDesign.design && props.selectedDesign.tabSwitch) {
      setActiveTab('images');
    }
  }, [props.selectedDesign.tabSwitch]);

  return (
    <Container className="dashboard">
      {displayLoginModal ? <LoginModal userState={props.userState} visible={displayLoginModal} formData={{ formData: props.formData }}/> : '' }
      <RateLimitUpgradeModal />
      <Col md={12} xl={12}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: '30px 0', paddingLeft: '15px' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '600', marginBottom: '10px' }}>Link Preview Tool</h2>
          <p style={{ fontSize: '1.1rem', color: '#494949' }}>Preview and Tune Your Social Media Links</p>
        </div>
      </Col>
      <Col md={12}>
        <LinkPreviewTool />
      </Col>
    </Container>
    )
};

const mapStateToProps = (state) => ({
  user: state.users.user,
  userState: state.users,
  plan: state.plans.detailPlan,
  planError: state.plans.error,
  api: state.apis.detailApi,
  formData: state.form.log_in_form,
  currentOrganization: state.organization.currentOrg,
  imageLayouts: state.linkPreview.imageLayouts,
  imageDesigns: state.linkPreview.imageDesigns,
  selectedDesign: state.linkPreview.selectedDesign,
});

const mapDispatchToProps = (dispatch) => ({
  getPlanByApiAndOrganization: (() => dispatch(getPlanByApiAndOrganization())),
  getApiByFriendlyName: (payload) => dispatch(getApiByFriendlyName(payload)),
  getImageLayouts: () => dispatch(getImageLayouts()),
  getOrganizationImageDesigns: () => dispatch(getOrganizationImageDesigns()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LinkPreview)
